// import { lazy } from "react";
import Login from "../pages/admin/login";
import UserMng from "../pages/admin/user-mng";

import Layout from "../pages/admin/components/layout";
import Header from "../pages/components/header";
import Front from "../pages/front";

const routes = [
  {
    path: '/9165/login',
    element: <Login />,
  },
  {
    path: '/9165/9165-admin',
    element: <Layout />,
    children: [
      {
        path: '/9165/9165-admin/user-mng',
        element: <UserMng />,
      }
    ]
  },
  {
    path: "/",
    element: <Header />,
    children: [
      {
        path: "/",
        element: <Front />,
      },
      {
        // 兜底
        path: "*",
        element: <Front />,
      },
    ],
  },
];

export default routes;
